/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsUnityOptionsDistributionComponentOptions, FxIdDomainSettingsUnityOptionsDistributionComponentOptionsFromJSONTyped, FxIdDomainSettingsUnityOptionsDistributionComponentOptionsToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionComponentOptions';
export function FxIdDomainSettingsUnityOptionsDistributionOptionsComponentFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsComponentFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionComponentOptions(json)) {
        return FxIdDomainSettingsUnityOptionsDistributionComponentOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsComponentToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsComponentToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionComponentOptions(value)) {
        return FxIdDomainSettingsUnityOptionsDistributionComponentOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionOptionsComponent.js.map